export default __webpack_public_path__ + "static/media/opensea.1a02203e.svg";